export default "__VITE_ASSET__BPZlRs97__"